<template>
  <v-app id="inspire">

    <!-- MENU DE NAVEGACIÓN-->
    <v-app-bar 
      dense 
      app
      color="primary"
      fixed
      class="header elevation-0"
      dark
     >
      <v-toolbar-title>
        <v-img src="https://surtimedix.com/fotos/logosurtimedix.png" width="150" contain @click="irHome"></v-img>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        dense
        v-model="search"
        outlined
        hide-details
        append-icon="search"
        label="Busqueda rápida"
        rounded
        dark
      >
      </v-text-field>
      <v-spacer></v-spacer>
      <v-btn  text color="white" :to="{name:'login'}" v-if="getLogeado==false" icon><v-icon>mdi-account-lock</v-icon></v-btn>
      <v-btn  text color="white" :to="{name:'login'}" v-else icon><v-icon>mdi-logout</v-icon></v-btn>

      <v-btn text color="white" @click="dialog=true" icon><v-icon @click.stop="ver" >shopping_cart</v-icon></v-btn>

      <template v-slot:extension>
        <v-toolbar-items text-right >
          <v-btn small text color="white" @click.stop="drawer = !drawer">LABORATORIOS</v-btn>
        </v-toolbar-items>
        <v-toolbar-items text-right >
          <v-btn small text color="white" :to="{name:'catarts'}" >CATÁLOGO</v-btn>
        </v-toolbar-items>
       <!--  <v-toolbar-items text-right >
          <v-btn small text color="white" @click="salir" >QUIÉNES SOMOS</v-btn>
        </v-toolbar-items> -->
        <v-toolbar-items text-right v-if="getLogeado == true">
          <!-- <v-btn small text color="white" @click="salir" >QUIÉNES SOMOS</v-btn> -->
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small text
                v-bind="attrs"
                v-on="on"
              >
                CUENTA
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, index) in tiles"
                :key="index"
                :to="{name: item.path}"
              >
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar-items>
      </template>
    </v-app-bar>

    <v-main>
      <v-container fluid class="elevation-0 transparent pt-0 mt-0 mt-0">
        <v-slide-y-transition mode="out-in">
          <router-view/>
        </v-slide-y-transition>
      </v-container> 
    </v-main>


    <!-- <v-main class="mt-12 pt-12 mx-0 px-0"> -->
      <!-- <v-slide-y-transition mode="out-in"> -->
        <!-- <router-view/> -->
      <!-- </v-slide-y-transition> -->
    <!-- </v-main> -->

    <v-navigation-drawer
      :clipped="$vuetify.breakpoint.lgAndUp"
      v-model="drawer"
      app
      left
      temporary
      >
      <v-text-field
       class="ma-2"
        label="Filtra por laboratorio"
        dense
        outlined
        hide-details
        v-model="search"
      ></v-text-field>

      <v-list dense>
        <v-list-group
          v-model="labDespliegue"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>LABORATORIOS</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="(lab, i) in filterLab"
            :key="i"
            @click="verArtxLab(lab)"
            color="primary"
          >
            <v-list-item-content class="pa-0">
              <v-list-item-title v-text="lab.nomlab.toUpperCase()"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-navigation-drawer>

    <v-navigation-drawer
      v-model="$store.state.carrito.carritovisible"
      app
      clipped
      right
      class="elevation-0"
      width="350"
      temporary
      >
      <Caja/>
    </v-navigation-drawer>

    <v-speed-dial
      fixed
      fab
      bottom
      right
      >
      <template v-slot:activator>
        <v-btn
          color="green "
          dark
          fab
          href="https://api.whatsapp.com/send?phone=528121058094&text=%C2%A1Hola!%20%C2%BFC%C3%B3mo%20podemos%20ayudarte?"
          target="_blank"
        >
          <v-icon large>mdi-whatsapp</v-icon>
        </v-btn>
      </template>
    </v-speed-dial>

    <v-footer  color="primary" dark  inset >
      <Footer/>
    </v-footer>
  </v-app>
</template>

<script>
  import Buscador    from '@/views/home/Buscador.vue'
  import axios from 'axios'
  import {mapGetters, mapActions} from 'vuex'
  import Caja from '@/views/Caja.vue'
  import Footer from '@/views/home/Footer.vue'
  var numeral = require('numeral');



  export default {
    components:{
      Caja,
      Footer,
      Buscador
    },

    props: {
      source: String,
    },


    data: () => ({
      total:0.00,
      telefono:'',
      search:'',
      laboratorios:[],
      drawer: false,
      item: 1,
      laboratorios: [],
      labDespliegue: true,

      opciones: [
        { text: 'Todos los artículos',   icon: 'style' , path: '/catarts'},
      ],
      logo:'',

      sheet: false,
      tiles: [
        { img: 'perfil.png',      title: 'Perfil'               ,path: 'miperfil'},
        { img: 'datosfis.jpg',    title: 'Datos fiscales'       ,path: 'datosfiscales'},
        { img: 'direcciones.png', title: 'Direcciones de envío' ,path: 'direcciones' },
        { img: 'compras.png',     title: 'Mis Compras'           ,path: 'miscompras' },
      ],
      search:'',

      url: '',

    }),

    watch:{
      getCarrito(){
        this.recalcular2()
      },

      search(){
        if(this.$router.history.current.name != 'catarts'){
          this.$router.push({name:'catarts'})
        }
        this.buscar(this.search)

      }
    },

    created(){
      this.init()
      this.traerArticulos()
      this.getTelefono()
    },

    methods:{
      ...mapActions('login',['salirLogin']),
      ...mapActions('articulos',['traerArticulos','routeLaboratorio','buscar']),

      unformat(string) {
        return numeral._.stringToNumber(string);
      },

      recalcular2(){
        
      },

      init(){
        this.url = this.$http.options.root + 'fotos/'
        this.color()
        this.getLaboratorios()
      },

      getLaboratorios(){
        this.$http.get('tienda/laboratorios.activos').then(response=>{
          this.laboratorios = response.body
        }).catch(error=>{console.log(error)})
      },

      color(){
        this.$http.get('config.list').then(response=>{
          var ciaws = response.body
          this.logo = this.$http.options.root + 'fotos/' + ciaws.logourl
          this.$vuetify.theme.themes.light.primary = ciaws.primario
          this.$vuetify.theme.themes.light.secondary = ciaws.secundario
          this.$vuetify.theme.themes.light.success = ciaws.correcto
          this.$vuetify.theme.themes.light.info = ciaws.informatico
          this.$vuetify.theme.themes.light.error = ciaws.errores
          this.$vuetify.theme.themes.light.warning = ciaws.peligro
        }, error => {
          console.log(error)
        })

      },

      irHome(){
        this.$router.push({name:'home'})
      },

      ver(){
        // EXPLICAR FUNCIOANLIDAD
        this.$store.state.carrito.carritovisible =! this.$store.state.carrito.carritovisible
        this.drawerRight = this.$store.state.carrito.carritovisible
      },

      salir(){
        this.$router.push({name:'login'}).catch(error=>{console.log(error)})
        this.salirLogin()
      },

      verArtxLab(lab){
        this.$router.push({name:'labart', params:{id: lab.idlaboratorios, detalle: lab}}).catch(error=>{console.log(error)})
      },

      home(){
        this.$router.push({name:'home'}).catch(error=>{console.log(error)})
      },

      getTelefono(){
        this.$http.get('tienda/datosfiscales').then(response=>{
          this.telefono = response.body[0].telefono
        }, error => {console.log(error)})

      },

      messenger(){

      },
      salir(){
        this.$router.push({name:'login'}).catch(error=>{console.log(error)})
        this.salirLogin()
      },
    },

    computed:{
      ...mapGetters('login',['getLogeado']),
      ...mapGetters('carrito',['getCarrito']),

      filterLab: function(){
        var me = this
        if(this.laboratorios){
          return this.laboratorios.filter((art)=>{
            var nom = art.nomlab.toLowerCase();
            return nom.match(this.search.toLowerCase());
          })
        }
      },

      activeFab () {
        switch (this.tabs) {
          case 'one': return { class: 'purple', icon: 'account_circle' }
          case 'two': return { class: 'red', icon: 'edit' }
          case 'three': return { class: 'green', icon: 'keyboard_arrow_up' }
          default: return {}
        }
      },
    }
  }
</script>

<style>
  /* This is for documentation purposes and will not be needed in your application */
  #create .v-speed-dial {
    position: absolute;
  }

  #create .v-btn--floating {
    position: relative;
  }
</style>